import { DsmdKeyItem, InstallationStatusValue } from '../domain/DTO'

export const installationStatus = (dsmdKeyItem: DsmdKeyItem) => {
  const aleStatus = dsmdKeyItem.aleCredentials?.status === InstallationStatusValue.OK
  const dpgStatus = dsmdKeyItem.dpgCredentials?.status === InstallationStatusValue.OK
  return Number(aleStatus) + Number(dpgStatus)
}
